module.exports = __webpack_public_path__ + "img/ground-river.9d373b7e.png";